const videoIcon = (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_669_26)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.1829 1.53659H2.81707C2.10988 1.53659 1.53659 2.10988 1.53659 2.81707V18.1829C1.53659 18.8901 2.10988 19.4634 2.81707 19.4634H18.1829C18.8901 19.4634 19.4634 18.8901 19.4634 18.1829V2.81707C19.4634 2.10988 18.8901 1.53659 18.1829 1.53659ZM2.81707 0C1.26125 0 0 1.26125 0 2.81707V18.1829C0 19.7388 1.26125 21 2.81707 21H18.1829C19.7388 21 21 19.7388 21 18.1829V2.81707C21 1.26125 19.7388 0 18.1829 0H2.81707Z"
        fill="#6B00DF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.1515 11.9493L8.80975 15.7296C7.59198 16.4556 6 15.6344 6 14.2803L6 6.71966C6 5.36559 7.59197 4.54443 8.80975 5.27036L15.1515 9.0507C16.2828 9.72512 16.2828 11.2749 15.1515 11.9493ZM14.451 10.9141C14.7743 10.7214 14.7743 10.2786 14.451 10.0859L8.10931 6.30557C7.76138 6.09816 7.30653 6.33278 7.30653 6.71966L7.30653 14.2803C7.30653 14.6672 7.76138 14.9018 8.10931 14.6944L14.451 10.9141Z"
        fill="#6B00DF"
      />
    </g>
    <defs>
      <clipPath id="clip0_669_26">
        <rect width="21" height="21" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const defaultEmptyIcon = (
  <svg
    width="50"
    height="50"
    viewBox="0 0 31 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Video Play</title>
    <path
      id="Video_Play"
      data-name="Video Play"
      d="M12.5,25A12.5,12.5,0,1,1,25,12.5,12.51,12.51,0,0,1,12.5,25Zm0-24A11.5,11.5,0,1,0,24,12.5,11.51,11.51,0,0,0,12.5,1Zm-3,17a.5.5,0,0,1-.5-.5V7.5a.5.5,0,0,1,.77-.42l8,5a.5.5,0,0,1,0,.85l-8,5A.5.5,0,0,1,9.5,18ZM10,8.4v8.2l6.55-4.1Z"
      fill="#707070"
    />
  </svg>
);

export { videoIcon, defaultEmptyIcon };
